import React from 'react';
import PropTypes from 'prop-types';

import TextInput from 'base/components/TextInput';

/**
 * This is text input component that needs to be used
 * as a component prop in redux-form.
 */
const TextInputField = props => {
  const { input, placeholder, maxLength, defaultValue, dataTestId } = props;
  return (
    <TextInput
      placeholder={placeholder}
      value={input.value}
      defaultValue={defaultValue}
      onChange={input.onChange}
      maxLength={maxLength}
      dataTestId={dataTestId}
    />
  );
};

TextInputField.propTypes = {
  input: PropTypes.object,
  placeholder: PropTypes.string,
  maxLength: PropTypes.string,
  defaultValue: PropTypes.string,
  dataTestId: PropTypes.string
};

export default TextInputField;
